<template>
  <div class="main-navbar">
    <b-row no-gutters>
      <b-col md="12">
        <!-- Mobile Navbar -->
        <div class="navbar-mobile">
          <div class="navbar-brand">
            <b>THE EAGLE</b>
          </div>
          <div class="navbar-icon navcloser" @click="hidesidenav">
            <i class="fa fa-list" aria-hidden="true"></i>
          </div>
        </div>
      </b-col>

      <b-col md="12">
        <!-- Desktop Navbar -->
        <div class="navbar-desktop">
          <div class="navbar-left">
            <p class="navbar-title"><strong>THE EAGLE</strong></p>
          </div>
          <div class="navbar-right">
            <div class="avatar-wrapper">
              <img src="logo.png" alt="Logo" />
            </div>
            <div class="icon-wrapper navcloser" @click="hidesidenav">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  methods: {
    hidesidenav() {
      window.Fire.$emit('hide-or-unhide-mobile-side');
    },
  },
};
</script>

<style scoped>
.main-navbar {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: linear-gradient(to left, #0f2027, #203a43, #2c5364);
  box-shadow: 15px 3px 10px rgba(0, 0, 0, 0.1);
}

/* Mobile Navbar */
.navbar-mobile {
  padding: 12px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  color: #fff;
}

.navbar-brand {
  font-weight: bold;
  font-size: 1.3em;
  color: #f5c518;
  letter-spacing: 1px;
}

.navbar-icon {
  font-size: 1.5em;
  color: #f0f0f0;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.3s ease;
}

.navbar-icon:hover {
  color: #f5c518;
  transform: scale(1.2);
}

/* Desktop Navbar */
.navbar-desktop {
  height: 70px;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

.navbar-title {
  font-size: 1.6em;
  color: #f5c518;
  letter-spacing: 2px;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.icon-wrapper {
  font-size: 1.4rem;
  color: #f0f0f0;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}

.icon-wrapper:hover {
  color: #f5c518;
  transform: scale(1.15);
}

.avatar-wrapper {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #f5c518;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.avatar-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

.avatar-wrapper:hover {
  transform: scale(1.08);
}

/* Responsive */
@media screen and (max-width: 991px) {
  .navbar-mobile {
    display: flex;
  }

  .navbar-desktop {
    display: none;
  }
}

@media screen and (min-width: 992px) {
  .navbar-mobile {
    display: none;
  }

  .navbar-desktop {
    display: flex;
  }
}
</style>
